import script from "./ProjectMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectMenu.vue?vue&type=script&setup=true&lang=js"

import "./ProjectMenu.vue?vue&type=style&index=0&id=07eb2fb4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07eb2fb4"]])

export default __exports__